export type CountrySelectItem = {
  key: string;
  label: string;
  prefix: string;
  value?: unknown;
  iconName?: string;
};

export const DEFAULT_COUNTRY: CountrySelectItem = {
  key: 'FR',
  label: 'FR',
  prefix: '+33',
};

export const PHONE_COUNTRIES: CountrySelectItem[] = [
  // France
  {
    key: 'FR',
    label: 'FR',
    prefix: '+33',
  },
  // Bruxelles
  {
    key: 'BE',
    label: 'BE',
    prefix: '+32',
  },

  // --- DOM-TOM ---
  // Guadeloupe
  {
    key: 'GP',
    label: 'GP',
    prefix: '+590',
  },
  // Martinique
  {
    key: 'MQ',
    label: 'MQ',
    prefix: '+596',
  },
  // Guyane
  {
    key: 'GF',
    label: 'GF',
    prefix: '+594',
  },
  // La Réunion
  {
    key: 'RE',
    label: 'RE',
    prefix: '+262',
  },
  // Mayotte
  {
    key: 'YT',
    label: 'YT',
    prefix: '+262',
  },
  // Saint-Pierre-et-Miquelon
  {
    key: 'PM',
    label: 'PM',
    prefix: '+508',
  },
  // Saint-Barthélemy
  {
    key: 'BL',
    label: 'BL',
    prefix: '+590',
  },
  // Saint-Martin
  {
    key: 'MF',
    label: 'MF',
    prefix: '+590',
  },
  // Wallis-et-Futuna
  {
    key: 'WF',
    label: 'WF',
    prefix: '+681',
  },
  // Polynésie française
  {
    key: 'PF',
    label: 'PF',
    prefix: '+689',
  },
  // Nouvelle-Calédonie
  {
    key: 'NC',
    label: 'NC',
    prefix: '+687',
  },

  // --- Voisins Caraïbes (GP, MQ, BL, MF) ---
  // Dominique
  {
    key: 'DM',
    label: 'DM',
    prefix: '+1767',
  },
  // Sainte-Lucie
  {
    key: 'LC',
    label: 'LC',
    prefix: '+1758',
  },
  // Barbade
  {
    key: 'BB',
    label: 'BB',
    prefix: '+1246',
  },
  // Antigua-et-Barbuda
  {
    key: 'AG',
    label: 'AG',
    prefix: '+1268',
  },
  // Anguilla
  {
    key: 'AI',
    label: 'AI',
    prefix: '+1264',
  },
  // Sint Maarten
  {
    key: 'SX',
    label: 'SX',
    prefix: '+1721',
  },

  // --- Voisins Amérique du Sud (GF) ---
  // Suriname
  {
    key: 'SR',
    label: 'SR',
    prefix: '+597',
  },
  // Brésil
  {
    key: 'BR',
    label: 'BR',
    prefix: '+55',
  },

  // --- Voisins Océan Indien (RE, YT) ---
  // Maurice
  {
    key: 'MU',
    label: 'MU',
    prefix: '+230',
  },
  // Madagascar
  {
    key: 'MG',
    label: 'MG',
    prefix: '+261',
  },
  // Comores
  {
    key: 'KM',
    label: 'KM',
    prefix: '+269',
  },

  // --- Voisins Pacifique (WF, PF, NC) ---
  // Samoa
  {
    key: 'WS',
    label: 'WS',
    prefix: '+685',
  },
  // Tonga
  {
    key: 'TO',
    label: 'TO',
    prefix: '+676',
  },
  // Fidji
  {
    key: 'FJ',
    label: 'FJ',
    prefix: '+679',
  },
  // Vanuatu
  {
    key: 'VU',
    label: 'VU',
    prefix: '+678',
  },
  // Australie
  {
    key: 'AU',
    label: 'AU',
    prefix: '+61',
  },

  // --- Voisins Atlantique Nord (PM) ---
  // Canada
  {
    key: 'CA',
    label: 'CA',
    prefix: '+1',
  },
];
